import { call, put } from 'redux-saga/effects';

import { Messages } from '../../../../codegen/Localize';
import { IExtractTaskInfo } from '../../../../ts/models/IExtractTaskInfo';
import { Set } from '../../../../ts/models/Set';
import { RunExtractTasksAction } from '../../../../extract/services/RunExtractTasksAction';
import { requestFailed } from '../../../actions/RequestFailedAction';
import { requestSpaceContents } from '../../../actions/spaces/RequestSpaceContentsActions';
import { RunExtractRefreshAction } from '../../../actions/spaces/RunExtractRefreshAction';

export function* handleRunExtractRefreshAction(action: RunExtractRefreshAction) {
  try {
    yield call(executeRunExtractRefresh, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeRunExtractRefresh(items: IExtractTaskInfo[]) {
  return RunExtractTasksAction.execute(Set.fromIdItemArray(items));
}
